import React from "react";
import "./QuantChrome.css";

/** Round gauge: how far the last price sits between the low (0%) and high (100%) of a range. */
export default function RangeGauge({ position, color = "#5fe0a8", track = "#17191d", text = "#eceef1", size = 56, label = "recent range" }) {
  if (!Number.isFinite(position)) return null;
  const pct = Math.round(position * 100);
  const r = size / 2 - 5;
  const circumference = 2 * Math.PI * r;
  const c = size / 2;
  return (
    <div className="lwt-gauge" style={{ width: size, height: size }} role="img" aria-label={`Price is at ${pct}% of the ${label}`} title={`Position in the ${label}: 0% = low, 100% = high`}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        <circle cx={c} cy={c} r={r} fill="none" stroke={track} strokeWidth="3" />
        <circle
          cx={c}
          cy={c}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray={`${(position * circumference).toFixed(1)} ${circumference.toFixed(1)}`}
          transform={`rotate(-90 ${c} ${c})`}
        />
        <circle cx={c} cy={c} r={r - 9} fill="none" stroke="rgba(110, 168, 255, 0.16)" strokeWidth="1" strokeDasharray="2 3" />
        <g className="lwt-gauge__orbit" style={{ transformOrigin: `${c}px ${c}px` }}>
          <circle cx={c} cy={c - r} r="2" fill="#6ea8ff" />
        </g>
      </svg>
      <span className="lwt-gauge__value" style={{ color: text }}>{pct}%</span>
    </div>
  );
}
